
angular.module('bmsApp.directives').controller('NoteListCtrl', ['$scope', '$log', 'NoteSvc', '$window', function ($scope, $log, NoteSvc, $window) {

		$scope.noteFilters = {
			show: false,
			view: 'full'
		};
		$scope.objectReady = false;
		$scope.notes = {
			itemsPerPage: 5,
			loading: true,
			totalCount: 0, // total count of notes belongs to object
			currentPage: 1,
			pageResult: [] // currently loaded paged results
		};
		$scope.noteAttachments = {
			loading: true,
			result: []
		};

		// Full notes

		$scope.$on('showNotes', function () {
			$scope.noteFilters.show = true;
			$scope.noteFilters.view = 'full';
			$scope.loadNotes($scope.objectType, $scope.objectId);
		});

		$scope.loadNotes = function (objectType, objectId) {
			$scope.notes.loading = true;
			if ($scope.objectReady) {
				var indexByObjectParams = {
					count:$scope.notes.itemsPerPage,
					page:$scope.notes.currentPage,
					objectType: objectType,
					objectId: objectId
				};
				NoteSvc.indexByObject(indexByObjectParams)
					.then(function (response) {
						$scope.notes.pageResult = response.data.note_collection;
						$scope.notes.totalCount = response.data.note_total_count;
						$scope.notes.loading = false;
					}, function (error) {
						$log.error(error);
						$scope.notes.loading = false;
					});
			}
		};

		$scope.noteFullView = function () {
			$scope.notes.currentPage = 1;
			$scope.loadNotes($scope.objectType, $scope.objectId);
		};

		// Note attachments

		$scope.loadNoteAttachments = function (objectType, objectId) {
			// use the note service without a page size and extract the attachments from there
			$scope.noteAttachments.loading = true;
			if ($scope.objectReady) {
				var indexByObjectParams = {
					page: 1,
					objectType: objectType,
					objectId: objectId
				};
				NoteSvc.indexByObject(indexByObjectParams)
					.then(function (response) {
						var noteAttachments = [];
						angular.forEach(response.data.note_collection, function (noteCollection) {
							angular.forEach(noteCollection.note_attachments, function (noteAttachment) {
								noteAttachments.push(noteAttachment);
							});
						});
						$scope.noteAttachments.result = noteAttachments;
						$scope.noteAttachments.loading = false;
				}, function (error) {
					$log.error(error);
					$scope.noteAttachments.loading = false;
				});
			}
		};

		$scope.noteAttachmentView = function () {
			$scope.loadNoteAttachments($scope.objectType, $scope.objectId);
		};

		$scope.$on('notesUpdated', function () {
			$scope.notes.currentPage = 1;
			$scope.loadNotes($scope.objectType, $scope.objectId);
		});
	
		$scope.notesPageChanged = function () {
			$scope.loadNotes($scope.objectType, $scope.objectId);
		};

		$scope.$watchGroup(['objectType', 'objectId'], function (newValues, oldValues) {
			var objectType = newValues[0];
			var objectId = newValues[1];
			if (angular.isString(objectType) && angular.isNumber(objectId)) {
				$scope.objectReady = true;
			}
			else {
				$scope.objectReady = false;
			}
		});

		$scope.downloadAttachment = function(filename) {
			$window.open('file/download/'+filename, '_blank');
		}
		
}]);
